export default __webpack_public_path__ + "static/media/undraw_apartment.ef9dc575.png";